import { useAtom } from 'jotai'
import { useState } from 'react'
import styled from 'styled-components'
import { videoElementAtom } from './atoms'
import { Play } from '@styled-icons/fluentui-system-filled/Play'

/*======================== React component ===================================*/

const BigPlayOverlay = (): JSX.Element => {
  const [active, setActive] = useState(true)
  const [videoElement] = useAtom(videoElementAtom)

  return (
    <Wrapper
      isActive={active}
      onTouchEnd={() => {
        videoElement!.play()
        setActive(false)
      }}
    >
      <BigPlay />
    </Wrapper>
  )
}

export default BigPlayOverlay

/*=========================== Styled Components ==============================*/

const BigPlay = styled(Play)`
  top: 50%;
  left: 50%;
  position: absolute;
  display: block;
  padding: 0;

  // mobile
  width: 15vw;

  // tablet+
  @media (min-width: 43em) {
    width: 15vw;
  }

  transform: translate(-50%, -50%);
`

const Wrapper = styled.div<{ isActive: boolean }>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.2);
  display: ${(props) => (props.isActive ? 'block' : 'none')};
`
